import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters, EXCLUDABLE_FILTERS } from '@/models/LinksGeneratorWorkflow/helpers'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import generatedLinksRepository from '@/repository/generatedRepository/generatedLinksRepository'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.LINKS_GENERATOR_WORKFLOW_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, payload) {
    const {isGenerating = false, ...filters} = payload
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.LINKS_GENERATOR_WORKFLOW_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    EXCLUDABLE_FILTERS.forEach(field => {
      const excludeKey = `${field}Exclude`
      if (Array.isArray(filters.filter?.[excludeKey])) appliedFilters[excludeKey] = filters.filter[excludeKey]
    })

    const preparedFilters = prepareFilters({
      ...appliedFilters,
      ...(isGenerating ? {generatedOfferPartnerLinks: filters.generatedOfferPartnerLinks} : {}),
    })

    const { data } = await generatedLinksRepository[isGenerating ? 'generateLink' : 'getOffers'](preparedFilters)

    if (!isGenerating) context.commit('setList', { data, filters })

    return data
  },
  async searchLinksGeneratorWorkflow(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })
    const { data } = await generatedLinksRepository.getOffers(preparedFilters)
    return { products: data.items, pagination: data.pagination }
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.LINKS_GENERATOR_WORKFLOW_FILTERS)
  },
  resetFilters({ commit }) {
    commit('setList', { data: [] })
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.LINKS_GENERATOR_WORKFLOW_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    if (!data.length) {
      state.list = []
      return
    }
    state.list = data.slice().sort((a, b) => (a.title || '').localeCompare(b.title || '', undefined, { numeric: true })).map(i => ({
      ...i,
      cost: i.cost_baseline ?? 0,
      baseLine: i.period_baseline ?? 0,
      maxDaysFromRegistration: i.max_day_from_reg ?? 0,
      betRequirement: i.bet_requirement ?? 0,
      countryMatching: i.country_matching ?? true,
    }))
    state.tableOptions = new TableOptions(null, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
